import type React from 'react';

/** Default max tilt for content boxes (readable). */
export const SKETCH_TILT_BOX_MAX = 0.25;

/** Default max tilt for buttons / small controls. */
export const SKETCH_TILT_BUTTON_MAX = 0.18;

/** Stable hand-drawn tilt in degrees from a seed, clamped to ±maxDeg. */
export function sketchTiltFromSeed(
  seed: string | number,
  maxDeg: number = SKETCH_TILT_BOX_MAX
): number {
  const s = String(seed);
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = (h * 31 + s.charCodeAt(i)) | 0;
  }
  const normalized = ((h % 200) - 100) / 100;
  return normalized * maxDeg;
}

export function sketchTiltStyle(
  seed: string | number,
  maxDeg: number = SKETCH_TILT_BOX_MAX
): React.CSSProperties {
  return { ['--sketch-tilt' as string]: `${sketchTiltFromSeed(seed, maxDeg)}deg` };
}
